module.exports = __webpack_public_path__ + "static/media/Office_Web@2x.039954ed.png";